import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';
import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

// Layers currently open above the page. A layer can appear more than once
// (two menus), so closing one keeps the other registered.
export const openHotkeyLayersState = createAtomState<HotkeyLayer[]>({
  key: 'openHotkeyLayersState',
  defaultValue: [],
});
